import { Button, Label, Spinner, TextInput } from 'flowbite-react';
import { FormEvent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isRecruiterSide, isUniversitySide } from 'src/config/env.config';
import { useThemeContext } from 'src/context/ThemeProvider';
import { sendTrackingEvent } from 'src/utils/gtm';

interface Props {
	emailOrPhone: string;
	handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
	setEmailOrPhone: (input: string) => void;
	isLoading: boolean;
}

const EnterPhoneOrEmail = ({ emailOrPhone, handleSubmit, setEmailOrPhone, isLoading }: Props) => {
	const { themeMode } = useThemeContext();
	const location = useLocation();
	const textInputStyle =
		themeMode === 'dark'
			? { color: 'white', backgroundColor: '#4B5563', border: '1px solid #6B7280' }
			: { color: 'black', backgroundColor: 'white', border: '1px solid #D1D5DB' };
	const searchParams = new URLSearchParams(window.location.search);
	const params = new URLSearchParams();
	searchParams.forEach((value, key) => {
		params.append(key, value);
	});
	return (
		<div className="sm:w-full sm:max-w-lg px-4 pt-3">
			<form className={'flex flex-col gap-4 shrink-0'} onSubmit={handleSubmit}>
				{isRecruiterSide ? (
					<div className="md:w-[358px]">
						<div className="mb-2 block">
							<Label className={'font-inter dark:text-[#fff] text-[#000]'} htmlFor="phone" value="Email address " />
							<span className="text-red-600">*</span>
						</div>
						<TextInput
							id="phone"
							sizing="lg"
							type="email"
							pattern={`^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`}
							placeholder="Email address"
							required={true}
							value={emailOrPhone}
							onChange={e => setEmailOrPhone(e.target.value)}
							style={textInputStyle}
						/>
					</div>
				) : (
					<div className="md:w-[358px]">
						<div className="mb-2 block">
							<Label
								className={'dark:text-[#fff] text-[#111928] font-inter'}
								htmlFor="phone"
								value="Phone or Email address "
							/>
							<span className="text-red-600">*</span>
						</div>
						<TextInput
							id="phone"
							sizing="lg"
							type="text"
							placeholder="10 digit phone or email address"
							required={true}
							value={emailOrPhone}
							onChange={e => setEmailOrPhone(e.target.value)}
							style={textInputStyle}
						/>
					</div>
				)}

				<Button
					color="purplePlaced"
					data-testid="auth-signup"
					disabled={isLoading || !emailOrPhone}
					type="submit"
					className={'signUp_form_btn'}
				>
					{isLoading ? <Spinner /> : 'Continue'}
				</Button>

				{isUniversitySide ? null : (
					<div>
						<div className="mb-5 flex gap-2 text-base dark:text-[#C7C9D9] text-[#28293D]">
							New member?
							<Link
								onClick={() => {
									if (isRecruiterSide) {
										sendTrackingEvent({
											event: 'recr_signin_register',
											eventLabel: location.pathname,
										});
									} else {
										sendTrackingEvent({
											event: 'sign_in_register',
											eventLabel: location.pathname,
										});
									}
								}}
								data-testid="auth-link-signin"
								className="text-[#7777E7]"
								to={`/auth/register?${params.toString()}`}
							>
								Register
							</Link>
						</div>
					</div>
				)}
			</form>
		</div>
	);
};

export default EnterPhoneOrEmail;
